import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { throwError, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { map, catchError, timeout } from 'rxjs/operators';
import { DatePipe } from '@angular/common';
import { TreinoProgramaDTO } from '../DTO/programaTreinoDTO';

@Injectable({
    providedIn: 'root'
})
export class ProgramaTreinoApiService {

    constructor(
        private http: HttpClient,
        private datePipe: DatePipe) { }

    private handleError(error: HttpErrorResponse) {
        if (error.error instanceof ErrorEvent) {
            // A client-side or network error occurred. Handle it accordingly.
            console.error('An error occurred:', error.error.message);
            console.log(error);
        } else {
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong,
            console.error(
                'Backend returned code ${error.status}, ' +
                'body was: ${error.error}');
        }
        // return an observable with a user-facing error message
        return throwError(error);
    }
    private extractData(res: Response) {
        return res;
    }

    getByProgramas(idprograma: string): Observable<any> {
        const url = environment.apiURL + 'programaTreino/getByPrograma/' + idprograma;

        const httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', Authorization: 'Bearer ' + window.localStorage.getItem('@CoachControl.token') })
        };

        return this.http.get(url, httpOptions).pipe(
            timeout(20000),
            map(this.extractData),
            catchError(this.handleError));
    }

    postTreino(data: TreinoProgramaDTO): Observable<any> {
        const url = environment.apiURL + 'programaTreino';

        const httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', Authorization: 'Bearer ' + window.localStorage.getItem('@CoachControl.token') })
        };

        return this.http.post(url, data, httpOptions)
            .pipe(
                timeout(20000),
                map(this.extractData),
                catchError(this.handleError)
            );
    }

    getTreinoPrograma(id: string): Observable<any> {
        const url = environment.apiURL + 'programaTreino/' + id;

        const httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', Authorization: 'Bearer ' + window.localStorage.getItem('@CoachControl.token') })
        };

        return this.http.get(url, httpOptions)
            .pipe(
                timeout(20000),
                map(this.extractData),
                catchError(this.handleError)
            );
    }

    alterarTreino(id: string, data: TreinoProgramaDTO): Observable<any> {
        const url = environment.apiURL + 'programaTreino/' + id;

        const httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', Authorization: 'Bearer ' + window.localStorage.getItem('@CoachControl.token') })
        };

        return this.http.put(url, data, httpOptions)
            .pipe(
                timeout(20000),
                map(this.extractData),
                catchError(this.handleError)
            );
    }

    deleteTreino(idTreino: string): Observable<any> {
        const url = environment.apiURL + 'programaTreino/' + idTreino;
    
        const httpOptions = {
          headers: new HttpHeaders({ 'Content-Type': 'application/json', Authorization: 'Bearer ' + window.localStorage.getItem('@CoachControl.token') })
        };
    
        return this.http.delete(url, httpOptions).pipe(
          timeout(20000),
          map(this.extractData),
          catchError(this.handleError));
      }
}